import React, { useEffect } from "react";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import ROUTES from "../../utils/routes";

export default function WantToKnowModal() {
  const { t } = useTranslation();
  const { token } = useAuth();
  const navigate = useNavigate();
  const { closeModal } = useModalActions();

  return (
    <BaseModal
      preventClose
      title={t("want_to_know")}
      eventTypeModal={MODAL_TYPES.WANT_TO_KNOW}
    >
      <BaseButton
        onClick={() => {
          closeModal(MODAL_TYPES.WANT_TO_KNOW);
          if (!token) {
            // «Да» = гость уже согласился узнать мнение партнёра и идёт
            // регистрироваться — допродажа +57 здесь не нужна. Флагом просим
            // /end-game НЕ открывать Extended57IntroModal на этой ветке.
            // item 26: state.fromWantToKnow ненадёжен — свайпер по таймеру
            // (checkEndGame) мог сам уйти на /end-game БЕЗ этого стейта раньше «Да»,
            // и +57-поп-ап всё равно вылетал. Дублируем решение в sessionStorage —
            // его EndGamePage проверяет независимо от порядка навигаций.
            sessionStorage.setItem("wepurplay_from_want_to_know", "1");
            navigate(ROUTES.END_GAME_PAGE, { state: { fromWantToKnow: true } });
          } else {
            navigate(ROUTES.PAYMENT_PAGE);
          }
        }}
      >
        {t("yes")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        onClick={() => {
          closeModal(MODAL_TYPES.WANT_TO_KNOW);
        }}
        className="modal-button-cancel"
      >
        {t("not_now")}
      </BaseButton>
    </BaseModal>
  );
}
